import { zodResolver } from '@hookform/resolvers/zod';
import type { z } from 'zod';

/**
 * Create a Zod resolver for React Hook Form
 */
export function createZodResolver<T extends z.ZodType<any, any>>(schema: T) {
    return zodResolver(schema);
}

// Export zodResolver for convenience (back-compat)
export { zodResolver };


